import React from 'react';

import TopBar from '../components/home/TopBar';
import Navigation from '../components/home/Navigation';
import Hero from '../components/home/Hero';
import Benefits from '../components/home/Benefits';
import Brands from '../components/home/Brands';
import Process from '../components/home/Process';
import BeforeAfter from '../components/home/BeforeAfter';
import Accessories from '../components/home/Accessories';
import FAQ from '../components/home/FAQ';
import Testimonials from '../components/home/Testimonials';
import ZonesIntervention from '../components/home/ZonesIntervention';
import SEOContent from '../components/home/SEOContent';
import FinalCTA from '../components/home/FinalCTA';
import Footer from '../components/home/Footer';
import WhatsAppButtons from '../components/home/WhatsAppButtons';
import MobileCollapse from '../components/MobileCollapse';
import { useSEO } from '../hooks/useSEO';

const HomePage = () => {
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);

  useSEO({
    title: 'Réparation iPhone & Samsung Saint-Chamond | Suro Phone - Écran, Batterie sur RDV',
    description: '✅ Réparation iPhone & Samsung à Saint-Chamond et dans toute la Loire (42) sur RDV ⚡ Écran cassé, batterie HS, connecteur. À domicile ou à l\'atelier, garantie 3 mois, devis gratuit. ☎️ 07.73.60.15.21',
    path: '/',
  });

  return (
    <div className="min-h-screen bg-white">
      <TopBar />
      <Navigation isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} />
      <Hero />
      <Benefits />
      <Process />
      <ZonesIntervention />
      <Testimonials />
      <MobileCollapse label="Voir les marques réparées et nos réalisations" testId="collapse-marques">
        <Brands />
        <BeforeAfter />
      </MobileCollapse>
      <FAQ />
      <MobileCollapse label="Accessoires et infos pratiques" testId="collapse-infos">
        <Accessories />
        <SEOContent />
      </MobileCollapse>
      <FinalCTA />
      <Footer />
      <WhatsAppButtons />
    </div>
  );
};

export default HomePage;
